import { useContext, useEffect, useRef, useState } from 'react';
import './index.scss';
import Busy from '../Components/Busy';
import { EventContext } from '../Contexts/Events';
import Modal from '../Components/Modal';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '../Contexts/Data';
import { AuthenticationContext } from '../Contexts/Authentication';

function Profile() {
    const eventHandler = useContext(EventContext);
    const dataLayer = useContext(DataContext);
    const loading = useRef(true);
    const navigate = useNavigate();
    const authentication = useContext(AuthenticationContext);
    const build_version = process.env.REACT_APP_VERSION || '0.0.0';

    const [profileState, setProfileState] = useState({
        busy: true,
        online: authentication.getOnline(),
        error: false as any,
        errors: {} as any,
        loading: false,
        profile: false as any
    });

    useEffect(() => {
        const receiveProfile = (profile: any) => {
            setProfileState({
                ...profileState, 
                busy: false,
                loading: false,
                profile: profile
            });
        }
        const networkChange = (online: any) => {
            setProfileState({...profileState, online});
        }
        if (loading.current) {
            eventHandler.trigger('profile:request');
            loading.current = false;
        }

        eventHandler.on('network:change', networkChange);
        eventHandler.on('profile:receive', receiveProfile);
        return () => {
            eventHandler.off('network:change', networkChange);
            eventHandler.off('profile:receive', receiveProfile);
        }
    }, [eventHandler, profileState, navigate]);

    const logout = () => {
        setProfileState({...profileState, busy: true});
        eventHandler.trigger('logout');
        navigate('/login');
    }

    const submit = async (e: any) => {
        e.preventDefault();

        const fd = new FormData(e.target);

        let errors: any = {};
        if (!fd.get('forename')) {
            errors.forename = 'First Name is required';
        }
        if (!fd.get('surname')) {
            errors.surname = 'Last Name is required';
        }
        if (!fd.get('email')) {
            errors.email = 'Email Address is required';
        }
        if (fd.get('password') !== null && fd.get('password_confirmation') !== null && fd.get('password') !== fd.get('password_confirmation')){
            errors.password = 'Passwords must match';
            errors.password_confirmation = 'Passwords must match';
        }

        if (Object.keys(errors).length === 0) {
            try {
                setProfileState({...profileState, errors: {}, loading: true});
                await dataLayer.getApi().post('/profile', fd);
                e.target.reset();
                eventHandler.trigger('profile:request');
            } catch (e) {
                console.error(e);
            }
        } else {
            setProfileState({...profileState, errors});
        }
    }

    return (
        <div className={`Profile ${profileState.busy ? 'is--busy' : ''}`}>

            {profileState.error !== false && (
                <Modal onDismiss={() => setProfileState({ ...profileState, error: false })} title={profileState.error.title}>{profileState.error.message}</Modal>
            )}
            {profileState.busy && (
                <Busy />
            )}
            {!profileState.busy && (
                <>
                    <form>
                        <button disabled={!profileState.online || profileState.loading} type="button" onClick={logout}>
                            {profileState.loading ? <Busy /> : 'Logout'}
                        </button>
                        <small>Version: {build_version} - <a href="/debug">Debug</a></small>
                    </form>
                    {/*<h1>Profile</h1>
                    <form method="post" onSubmit={submit}>
                        <label>First Name</label>
                        <input type="text" className={('forename' in profileState.errors ? 'has-error' : '')} disabled={!profileState.online || profileState.loading} autoComplete="first-name" defaultValue={profileState.profile.forename} name="forename" placeholder="First Name" />
                        <label>Last Name</label>
                        <input type="text" className={('surname' in profileState.errors ? 'has-error' : '')} disabled={!profileState.online || profileState.loading} autoComplete="last-name" defaultValue={profileState.profile.surname} name="surname" placeholder="Last Name" />
                        <label>Email Address</label>
                        <input type="email" className={('email' in profileState.errors ? 'has-error' : '')} disabled={!profileState.online || profileState.loading} autoComplete="email" defaultValue={profileState.profile.email} name="email" placeholder="Email Address" />
                        <br />
                        <label>New Password</label>
                        <input type="password" className={('password' in profileState.errors ? 'has-error' : '')} disabled={!profileState.online || profileState.loading} autoComplete="new-password" name="password" placeholder="New Password" />
                        <label>Confirm New Password</label>
                        <input type="password" className={('password_confirmation' in profileState.errors ? 'has-error' : '')} disabled={!profileState.online || profileState.loading} autoComplete="confirm-new-password" name="password_confirmation" placeholder="Confirm New Password" />
                        <small>Only enter a password when wishing to change it.</small>
                        <br />
                        <br />
                        <button disabled={!profileState.online || profileState.loading}>
                            {profileState.loading ? <Busy /> : 'Update Profile'}
                        </button>
                        <button disabled={!profileState.online || profileState.loading} type="button" onClick={logout}>
                            {profileState.loading ? <Busy /> : 'Logout'}
                        </button>
                        <small>Version: {build_version} - <a href="/debug">Debug</a></small>
                    </form>*/}
                </>
            )}
        </div>
    )
}

export default Profile;